<template>
	<div class="list-item-summary-editor">
		<ModalHeader
			:title="getString('edit_x', [currentItemName])"
			:button-text="getString('confirm')"
			@click-button="clickConfirmItem"
		/>
		<AppList :items="editVariationFields">
			<template v-slot:dropdown-name="{item}">
				<div class="row flex-end">
					<AppTextInput ref="name-input" :value="listItem?.product_name" @changed-text="v=>productName = v" />
				</div>
			</template>
			<template v-slot:dropdown-price="{item}">
				<div class="row flex-end">
					<AppNumberInput ref="price-input" double-decimal :label="getString('price_symbol', [this.currencyStore.currCurrency.symbol])" @changed-value="changedProductValue" :min="0" :value="currencyStore.dbToActualValue(listItem?.product_price)" />
				</div>
			</template>
		</AppList>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";

import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		let menuStore = useMenuStore();
		let userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, currencyStore, menuStore};
	},
	name: "ListItemEditor",
	emits: ['confirm-list-item', 'delete-product'],
	components: {AppTextInput, AppNumberInput, AppList, ModalHeader },
	props: {
		listItem: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			productName: null,
			productPrice: null,
			linkedName: true,
			linkedPrice: true,
		};
	},
	computed: {
		currentLinkedMenuItem() {
			if(this.menuStore.items && this.listItem && this.listItem?.menu_item_linked_id && this.menuStore.items[this.listItem.menu_item_linked_id]) {
				return this.menuStore.items[this.listItem.menu_item_linked_id];
			}
			return {};
		},
		currentItemName() {
			return this.listItem?.product_name || this.getString('variation');
		},
		editVariationFields() {
			if(!this.listItem?.meta_product) {
				return [
					{
						title: this.getString('unlinked_name'),
						explain: this.getString('unlinked_name_explain'),
						switch: true,
						active: !this.linkedName,
						dropdownSlot: 'dropdown-name',
						callback: this.switchName
					},
					{
						title: this.getString('unlinked_price'),
						explain: this.getString('unlinked_price_explain'),
						switch: true,
						active: !this.linkedPrice,
						dropdownSlot: 'dropdown-price',
						value: this.currencyStore.dbToActualValue(this.listItem?.price),
						callback: this.switchPrice

					},
					{
						title: this.getString('delete'),
						buttonTitle: this.getString('delete'),
						callbackButton: this.emitDelete
					}
				]
			} else {
				return [
					{
						title: this.getString('available'),
						switch: true,
						active: !!this.listItem?.available,
						value: !!this.listItem?.available,
						callback: v => this.productAvailable = v,
					},
					{
						title: this.getString('product_name_placeholder'),
						placeholder: this.getString('name'),
						textInput: true,
						value: this.listItem?.product_name || '',
						callbackText: v => this.productName = v,
					},
					{
						title: this.getString('addition_price_symbol', [this.currencyStore.currCurrency.symbol]),
						placeholder: this.getString('price'),
						numberInput: true,
						min: 0,
						doubleDecimal: true,
						value: this.currencyStore.dbToActualValue(this.listItem?.product_price),
						callbackNumber: this.changedProductValue,
					},
					{
						title: this.getString('delete'),
						buttonTitle: this.getString('delete'),
						callbackButton: this.emitDelete
					}
				]
			}
		}
	},
	methods: {
		changedProductValue(value) {
			this.productPrice = this.currencyStore.actualToDbValue(value);
		},
		emitDelete() {
			this.$emit('delete-product');
		},
		clickConfirmItem() {
			this.$emit('confirm-list-item', {
				listItem: this.listItem,
				available: this.productAvailable,
				productName: this.productName,
				productPrice: this.productPrice,
				linkedName: this.linkedName,
				linkedPrice: this.linkedPrice,
			});
		},
		switchName(val){
			this.linkedName = !val;
			if(!!this.linkedName) {
				this.productName = this.currentLinkedMenuItem.name;
			}
		},
		switchPrice(val) {
			this.linkedPrice = !val;
			if(!!this.linkedPrice) {
				this.productPrice = this.currentLinkedMenuItem.price;
			}
		},
	},
	mounted() {
		this.productAvailable = !!this.listItem?.available;
		this.productName = this.listItem?.product_name;
		this.productPrice = this.listItem?.product_price;
		this.linkedName = !!this.listItem?.linked_name;
		this.linkedPrice = !!this.listItem?.linked_price;
	}
}
</script>

<style lang="scss" scoped>


</style>